import moment from "moment";

export default class ProfitAndLoss {
  /**
   *
   * @param {string} earliestAvailableMonth
   * @param {string} mostRecentAvailableMonth
   * @param {FinancialAccount} costOfSales
   * @param {FinancialAccount} expenses
   * @param {float} grossProfit
   * @param {FinancialAccount} income
   * @param {float} netOperatingProfit
   * @param {float} netOtherIncome
   * @param {FinancialAccount} otherExpenses
   * @param {FinancialAccount} otherIncome
   * @param {string} fromDateReport
   * @param {string} toDateReport
   * @param {float} netProfit
   */
  constructor({
    companyId,
    earliestAvailableMonth,
    mostRecentAvailableMonth,
    costOfSales,
    expenses,
    grossProfit,
    income,
    netOperatingProfit,
    netOtherIncome,
    otherExpenses,
    otherIncome,
    fromDateReport,
    toDateReport,
    netProfit,
  }) {
    this.companyId = companyId;
    this.earliestAvailableMonth = earliestAvailableMonth;
    this.mostRecentAvailableMonth = mostRecentAvailableMonth;
    this.costOfSales = costOfSales;
    this.expenses = expenses;
    this.grossProfit = grossProfit;
    this.income = income;
    this.netOperatingProfit = netOperatingProfit;
    this.netOtherIncome = netOtherIncome;
    this.otherExpenses = otherExpenses;
    this.otherIncome = otherIncome;
    this.fromDateReport = fromDateReport;
    this.toDateReport = toDateReport;
    this.netProfit = netProfit;
  }

  get formattedEarliestAvailableMonth() {
    return moment(this.earliestAvailableMonth).format("MMMM YYYY");
  }

  get formattedMostRecentAvailableMonth() {
    return moment(this.mostRecentAvailableMonth).format("MMMM YYYY");
  }

  static getIncomeCategories() {
    return {
      BUSINESS_REVENUE_CATEGORY: {
        name: "Business Revenue",
        value: "BUSINESS_REVENUE_CATEGORY",
      },
      INTEREST_INCOME_CATEGORY: {
        name: "Interest Income",
        value: "INTEREST_INCOME_CATEGORY",
      },
    };
  }

  static getCostOfSalesCategories() {
    return {
      COST_OF_SALES_CATEGORY: {
        name: "Cost of Sales",
        value: "COST_OF_SALES_CATEGORY",
      },
      COST_OF_SALES_LABOR_CATEGORY: {
        name: "Cost of Sales-Labor Portion",
        value: "COST_OF_SALES_LABOR_CATEGORY",
      },
    };
  }

  static getExpensesCategories() {
    return {
      OFFICERS_COMPENSATION_CATEGORY: {
        name: "Officers Compensation",
        value: "OFFICERS_COMPENSATION_CATEGORY",
      },
      SALARY_WAGES: {
        name: "Salary-Wages",
        value: "SALARY_WAGES",
      },
      RENT_CATEGORY: {
        name: "Rent",
        value: "RENT_CATEGORY",
      },
      TAXES_PAID_CATEGORY: {
        name: "Taxes Paid",
        value: "TAXES_PAID_CATEGORY",
      },
      ADVERTISING_CATEGORY: {
        name: "Advertising",
        value: "ADVERTISING_CATEGORY",
      },
      BENEFITS_PENSION_CATEGORY: {
        name: "Benefits-Pensions",
        value: "BENEFITS_PENSION_CATEGORY",
      },
      REPAIRS_CATEGORY: {
        name: "Repairs",
        value: "REPAIRS_CATEGORY",
      },
      BAD_DEBT_EXPENSE_CATEGORY: {
        name: "Bad Debt",
        value: "BAD_DEBT_EXPENSE_CATEGORY",
      },
      SALES_AND_GENERAL_AND_ADMINISTRATIVE: {
        name: "Sales, General and Administrative",
        value: "SALES_AND_GENERAL_AND_ADMINISTRATIVE",
      },
      AMORTIZATION_DEPRECIATION_DEPLETION_CATEGORY: {
        name: "Amortization Depreciation Depletion",
        value: "AMORTIZATION_DEPRECIATION_DEPLETION_CATEGORY",
      },
      INTEREST_EXPENSE_CATEGORY: {
        name: "Interest Expense",
        value: "INTEREST_EXPENSE_CATEGORY",
      },
      INCOME_TAX_EXPENSE_CATEGORY: {
        name: "Income Tax",
        value: "INCOME_TAX_EXPENSE_CATEGORY",
      },
      OTHER_CATEGORY: {
        name: "Other",
        value: "OTHER_CATEGORY",
      },
    };
  }

  static getOtherIncomesCategories() {
    return {
      OTHER_INCOME_CATEGORY: {
        name: "Other Income",
        value: "OTHER_INCOME_CATEGORY",
      },
    };
  }

  static getOtherExpensesCategories() {
    return {
      OTHER_EXPENSE_CATEGORY: {
        name: "Other Expense",
        value: "OTHER_EXPENSE_CATEGORY",
      },
    };
  }

  static getCategoriesOptions(groupName) {
    let categories = [];

    if (["incomes"].includes(groupName))
      categories = this.getIncomeCategories();
    if (["costOfSales"].includes(groupName))
      categories = this.getCostOfSalesCategories();
    if (["expenses"].includes(groupName))
      categories = this.getExpensesCategories();
    if (["otherIncomes"].includes(groupName))
      categories = this.getOtherIncomesCategories();
    if (["otherExpenses"].includes(groupName))
      categories = this.getOtherExpensesCategories();

    return Object.keys(categories).map((category) => {
      const _category = categories[category];

      return {
        name: _category.name,
        value: _category.value,
      };
    });
  }
}
